<template>
  <div class="hidden relative lg:block col-span-2">
    <circle-button
      :enable-click="!disabled"
      icon="eye"
      label="Visualiser"
      title="Visualiser"
      @buttonClick="$emit('showSheet', false)"
      icon-scale="110"
    />
    
    <circle-button
      :enable-click="!disabled"
      v-if="canExport"
      icon="download"
      label="Exporter"
      title="Exporter"
      @buttonClick="$emit('export')"
    />

    <circle-button
      :enable-click="!disabled"
      v-if="canDelete && !usedInEval"
      icon="close"
      label="Supprimer"
      title="Supprimer"
      @buttonClick="$emit('delete')"
      icon-scale="75"
    />

    <div
      class="relative cursor-not-allowed inline-flex"
      @mouseenter="cantDeleteToolTip = true"
      @mouseleave="cantDeleteToolTip = false"
    >
      <circle-button
        v-if="canDelete && usedInEval"
        icon="close"
        icon-scale="75"
        icon-color="text-gray-600"
        bg-color="bg-gray-300"
        bg-color-hover="bg-gray-300"
        border-color="border-gray-600"
      />
    </div>

    <transition
      enter-active-class="duration-300"
      enter-class="opacity-0"
      enter-to-class="opacity-100"
      leave-active-class="duration-300"
      leave-class="opacity-100"
      leave-to-class="opacity-0"
    >
      <div
        v-show="cantDeleteToolTip"
        v-html="
          'Vous ne pouvez pas supprimer ' +
            (type === 'sheet'
              ? 'cette fiche de poste'
              : 'ce référentiel de formation') +
            ' car il y a une évaluation en cours.'
        "
        class="tooltip-Label bg-indigo-600 text-white flex absolute rounded-lg shadow-lg text-xs z-50 py-3 px-4 bottom-10 -right-10 w-max-content w-max max-w-64 md:max-w-72 xl:max-w-80"
      />
    </transition>

    <circle-button
      :enable-click="!disabled"
      v-if="canDupe"
      icon="clipboard-text"
      title="Dupliquer"
      label="Dupliquer"
      @buttonClick="$emit('duplicate')"
      icon-scale="110"
    />
  </div>
</template>
<script>
import CircleButton from '../components/CircleButton.vue';

export default {
  components: {
    CircleButton
  },
  props: {
    disabled: {
      type: Boolean,
      required: true
    },
    type: {
      type: String,
      required: true
    },
    canExport: {
      type: Boolean,
      required: true
    },
    canDelete: {
      type: Boolean,
      required: true
    },
    canDupe: {
      type: Boolean,
      required: true
    },
    usedInEval: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      cantDeleteToolTip: false
    };
  }
};
</script>